import { ShareButtonNext } from 'components/common-form/sidePanel/docToolbar/summary';
import { FormattedMessage } from 'components/shared/Intl';
import { LightAlert } from 'components/shared/LightAlert';
import {
  ConnectedTradeWayLiteral,
  FlowWayLiteral,
  PriceNext,
  QuoteStatus,
  SolveResult,
} from 'components/shared/PriceNext';
import type { PropsWithChildren } from 'react';

import { SolveModeLabel } from '../SolveMode';
import type { TradeDoneState } from './trade.done.connect';
import { connectTradeDone } from './trade.done.connect';

export function RawTradeDoneComponent({
  hasBookingSkippedWarning,
  isForBooking,
  workspaceType,
  tabId,
  solvingMode,
  isMultipleSolvingMode,
  solveResult,
  solveResultFormat,
  priceInPercent = 0,
  priceInCurrency = 0,
  currency = '',
  flowWay,
}: PropsWithChildren<TradeDoneState>) {
  const isDynamicWorkspace = workspaceType === 'dynamic';
  const hasSolveResult = solveResult !== undefined;

  return (
    <>
      <PriceNext
        className={'sg-price bg-info bg-opacity-10 text-info'}
        tradeWay={<ConnectedTradeWayLiteral tabId={tabId} workspaceType={workspaceType} />}
        solveMode={
          <SolveModeLabel
            workspaceType={workspaceType}
            solvingMode={solvingMode}
            isMultipleSolvingMode={isMultipleSolvingMode}
          />
        }
        shareButton={!isDynamicWorkspace && <ShareButtonNext className="text-info" tabId={tabId} />}
        solveResult={<SolveResult price={solveResult} priceFormat={solveResultFormat} />}
        flowWay={
          hasSolveResult && (
            <FlowWayLiteral
              flowWay={flowWay}
              priceInPercent={priceInPercent}
              priceInCurrency={priceInCurrency}
              currency={currency}
            />
          )
        }
        quoteStatus={
          <QuoteStatus
            className="bg-info"
            icon="check_circle"
            description={isForBooking ? 'sidePanel.quoteStatus.tradeBooked' : 'sidePanel.quoteStatus.tradeTraded'}
          />
        }
      />
      {hasBookingSkippedWarning && (
        <LightAlert className="mt-3 mx-3" severity="warning" e2e="booking-skipped-warning">
          <FormattedMessage id="form.status.tradeDone.bookingSkippedWarning" />
        </LightAlert>
      )}
    </>
  );
}

RawTradeDoneComponent.displayName = 'TradeDoneComponent';

export const TradeDoneComponent = connectTradeDone(RawTradeDoneComponent);
